import type { HelpWidgetMessageSource } from "../../types/help_widget_message";

interface ChatMessageSourcesProps {
  areSourcesVisible: boolean;
  sources: HelpWidgetMessageSource[];
}

export const ChatMessageSources = ({
  sources,
  areSourcesVisible,
}: ChatMessageSourcesProps) => {
  if (!sources || sources.length === 0) return null;

  return (
    <div
      className="flex flex-col gap-2 overflow-hidden transition-all duration-300 ease-out"
      style={{
        transform: "translateZ(0)",
        maxHeight: areSourcesVisible ? `${sources.length * 28}px` : "0px",
        opacity: areSourcesVisible ? 1 : 0,
        marginTop: areSourcesVisible ? "8px" : "0px",
      }}
    >
      {sources.map((source, index) => (
        <div key={source.url} className="flex items-center gap-2">
          <span className="flex size-4 shrink-0 items-center justify-center rounded-full bg-secondary text-center text-[10px] font-normal leading-4 tracking-[0.2px] text-tertiary">
            {index + 1}
          </span>
          <a
            href={source.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-tertiary hover:text-darkest truncate text-xs font-normal leading-[18px] tracking-[0.2px] underline transition-colors"
            style={{
              textDecorationStyle: "solid",
              textDecorationSkipInk: "auto",
              textUnderlinePosition: "from-font",
            }}
          >
            {source.title}
          </a>
        </div>
      ))}
    </div>
  );
};
